import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivitiesServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { forkJoin, ReplaySubject, Subject } from '@node_modules/rxjs';
import { FormControl } from '@angular/forms';
import { takeUntil } from '@node_modules/rxjs/operators';

@Component({
    selector: 'material-table-filter',
    templateUrl: './material-table-filter.component.html',
    styleUrls: ['./material-table-filter.component.less']
})
export class MaterialTableFilterComponent extends AppComponentBase implements OnInit {
    filterText;

    materialName;
    suppliers;

    constructor(
        injector: Injector,
        private _activitiesServiceProxy: ActivitiesServiceProxy,
    ) {
        super(injector);
    }
    @Output() onFiltersChange: EventEmitter<any> = new EventEmitter<any>();

    public locationFormCtrl: FormControl = new FormControl();
    public locationFilterFormCtrl: FormControl = new FormControl();
    public filteredLocation: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

    public supplierFormCtrl: FormControl = new FormControl();
    public supplierFilterFormCtrl: FormControl = new FormControl();
    public filteredSupplier: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);


    protected _onDestroy = new Subject<void>();
    ngOnInit(): void {
        const editData = forkJoin({
            names: this._activitiesServiceProxy.getMaterialNames(),
            suppliers: this._activitiesServiceProxy.getMaterialSuppliers()
        });
        editData.subscribe((data) => {
            this.filteredLocation.next(data.names.slice());
            this.filteredSupplier.next(data.suppliers.slice());

            this.materialName = data.names;
            this.suppliers = data.suppliers;
        });
        this.initiateFiltersValueChanges();
    }
    private initiateFiltersValueChanges() {
        this.locationFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterLocations();
            });

        this.supplierFilterFormCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterVendors();
            });
    }
    refresh() {
        this.filtersChange();
    }
    clear() {
        this.filterText = null;
        this.locationFormCtrl.reset();
        this.supplierFormCtrl.reset();
        this.filtersChange();
    }
    filtersChange() {
        const params = {
            filterText: this.filterText,
            materialName: this.locationFormCtrl.value || null,
            supplier: this.supplierFormCtrl.value || null,
        };

        this.onFiltersChange.emit(params);
    }


    protected filterLocations() {
        if (!this.materialName) {
            return;
        }

        let search = this.locationFilterFormCtrl.value;
        if (!search) {
            this.filteredLocation.next(this.materialName.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredLocation.next(
            this.materialName?.filter(
                (materialName) => materialName.locationName.toLowerCase().indexOf(search) > -1
            )
        );
    }

    protected filterVendors() {
        if (!this.suppliers) {
            return;
        }

        let search = this.supplierFilterFormCtrl.value;
        if (!search) {
            this.filteredSupplier.next(this.suppliers.slice());
            return;
        } else {
            search = search.toLowerCase();
        }

        this.filteredSupplier.next(
            this.suppliers?.filter(
                (supplier) => supplier.trade.toLowerCase().indexOf(search) > -1
            )
        );
    }
}
